<template>

</template>

<script>
  import axios from '@/utils/axios.js'

  export default {
    name: 'singleLogin',
    data() {
      return {
        code: ''
      }
    },
    created() {
      // 从路由参数中获取传递的参数
      let _this = this
      // 获取当前 URL 中的查询参数部分
      const queryString = window.location.search;
// 使用正则表达式匹配出 code 参数的值
      const regex = /code=([^&]+)/;
      const match = regex.exec(queryString);
// 获取 code 参数的值
      _this.code = match && match[1];
      console.log(this.code + "获取到的code")
      // let options = {
      //   url: '/base/login/singleLoginByRegulatory',
      //   data: {'code': _this.code}
      // }
      // 将参数传递给后端
      axios.post1('/base/login/singleLoginByRegulatory', {code: _this.code, message: "message"})
        .then(response => {
          _this.$router.push('/login');
          let data = response.data.data;
          // 处理后端返回的数据
          if (data && data.i == 1) {
            let sysInfo = data.account;
            sysInfo.session = data.sessionId;
            _this.$store.dispatch('setSystemInfo', sysInfo);
            if (sysInfo.role.id == "sp") {
              _this.$router.push('/check');
            } else {
              _this.$router.push('/fillout');

            }

          }// 直接跳到登陆
          else if (data && data.i == -2) {
            _this.$router.push('/login');
          }


        })
        .catch(error => {
          console.error(error)
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/singleLogin/singleLogin.vue